import { Component, OnInit, OnDestroy, ChangeDetectorRef, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ProductService } from 'src/app/services/product.service';
import { ConfirmationService } from 'primeng/api'; import { MessageService } from 'primeng/api';
import { Apps, StoreAppsResponse, StoreAppCreationResponse, StoreApps } from 'src/app/models/apps';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { PedidosService } from 'src/app/services/pedidos.service';
import { catchError, switchMap, finalize, map } from 'rxjs/operators';
import { of, EMPTY } from 'rxjs'; import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { GoogleAccountVM } from 'src/app/models/google-account-vm';
import { Ga4AccountVM } from 'src/app/models/ga4-account-vm';
import { NuvemshopAccountVM } from 'src/app/models/nuvemshop-account-vm';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router'; import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
export interface TiktokAccountVM {
  uid: string;               // open_id
  username?: string | null;  // username
  name?: string | null;      // display_name
  picture?: string | null;   // avatar_url
}
@Component({
  selector: 'app-apps',
  templateUrl: './apps.component.html',
  styleUrls: ['./apps.component.scss']
})
export class AppsComponent implements OnInit, OnDestroy {
  products: Apps[] = [];
  selectedProduct: Apps | null = null; // Para armazenar o produto selecionado
  showSidebar: boolean = false; // Controle da visibilidade da sidebar

  selectedStoreApp: StoreApps | null = null;
  private pendingIntegrationSidebarKey: string | null = null;
  private lastIntegrationFeedbackKey: string | null = null;

  constructor(private productService: ProductService,
    private route: ActivatedRoute, private router: Router,
    private pedidosService: PedidosService,
    private cdr: ChangeDetectorRef,
    private errorHandler: ErrorHandlerService,
    private auth: AuthService, private confirmationService: ConfirmationService, private messageService: MessageService,
    private injector: Injector) {
    console.log('[Capacitor] referenced in AppsComponent');
  }
  store_id: number | undefined;
  loadingProducts = true;
  ngOnInit() {

    const pendingIntegration = localStorage.getItem('openIntegrationSidebar');
    if (pendingIntegration) {
      localStorage.removeItem('openIntegrationSidebar');
      this.pendingIntegrationSidebarKey = pendingIntegration;
    }

    // /apps#nuvemshop ou /apps#shopify abre a sidebar da integração direto,
    // reaproveitando o mesmo mecanismo de "pending sidebar" usado no retorno
    // do OAuth (tryOpenPendingIntegrationSidebar), só que disparado por
    // navegação manual via fragment em vez de query params.
    const fragment = this.route.snapshot.fragment;
    if (fragment) {
      this.pendingIntegrationSidebarKey = fragment;
    }

    // Listener sempre ativo (web + native)
      this.sub = this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event) => {
        this.handleIntegrationQueryParams();
        return;
        // Aqui SEMPRE é chamado, mesmo se já estava na rota
        const integration = this.route.snapshot.queryParamMap.get('integration');
        const result = this.route.snapshot.queryParamMap.get('result');
        if (integration && (!result || result === 'success')) {
          this.messageService.add({
            severity: 'success',
            summary: `Integração realizada com sucesso`,
            detail: `Integração concluída!`
          });
          this.pendingIntegrationSidebarKey = integration;
          this.tryOpenPendingIntegrationSidebar();

          // Limpa params depois se quiser
          setTimeout(() => {
            this.router.navigate([], {
              queryParams: { integration: null, result: null },
              queryParamsHandling: 'merge',
              replaceUrl: true
            });
          }, 100);
        }
      });
    this.handleIntegrationQueryParams();
    this.initializeApps();
  }

  private handleIntegrationQueryParams(): void {
    const integration = this.route.snapshot.queryParamMap.get('integration');
    const result = this.route.snapshot.queryParamMap.get('result');

    if (!integration) return;
    if (result && result !== 'success') return;

    const feedbackKey = `${integration}:${result || 'success'}`;
    if (this.lastIntegrationFeedbackKey === feedbackKey) return;
    this.lastIntegrationFeedbackKey = feedbackKey;

    this.messageService.add({
      severity: 'success',
      summary: 'Integração realizada com sucesso',
      detail: 'Integração concluída!'
    });

    this.pendingIntegrationSidebarKey = integration;
    this.tryOpenPendingIntegrationSidebar();

    setTimeout(() => {
      this.router.navigate([], {
        queryParams: { integration: null, result: null },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }, 100);
  }

  private tryOpenPendingIntegrationSidebar(): void {
    if (!this.pendingIntegrationSidebarKey) return;
    if (!Array.isArray(this.products) || this.products.length === 0) return;

    const product = this.products.find(p => p.key === this.pendingIntegrationSidebarKey);
    if (!product) return;

    this.pendingIntegrationSidebarKey = null;
    setTimeout(() => this.onProductClick(product, { ignoreEcommerceLock: true }), 0);
  }

  initializeApps(): void {
    this.loadingProducts = true;
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    if (selectedStoreId) {
      this.store_id = Number(selectedStoreId);
    }

    // Cache-first com ETag (src/app/core/http-cache).
    const appsPublicResource = this.productService.getAppsPublicStoreRevalidated();

    toObservable(appsPublicResource.data, { injector: this.injector }).pipe(
      filter((response): response is any => response !== null)
    ).subscribe(response => {
        this.products = (response.apps || []).map((app: any) => ({
          ...app,
          isPinned: app.store_active?.toString() === 'active'
        }));
        this.loadingProducts = false;
        this.tryOpenPendingIntegrationSidebar();
    });

    toObservable(appsPublicResource.error, { injector: this.injector }).pipe(
      filter((error): error is any => error !== null)
    ).subscribe(error => {
        this.loadingProducts = false;
        console.error('Erro ao carregar os apps:', error);
    });

    this.fetchUserData();
  }

  userSubType?: number;
  userSubsStatus?: string;
  fetchUserData() {
    this.auth.me().subscribe({
      next: (userData: any) => {
        console.log('userData')
        console.log(userData)


        const subType = userData?.sub_type ?? userData?.plan?.sub_type ?? 0;
        const subsStatus = userData?.subs_status ?? userData?.plan?.subs_status ?? '';

        this.userSubType = Number(subType) || 0;
        this.userSubsStatus = subsStatus?.toString()?.toLowerCase() || '';
      },
      error: (err: any) => {
        console.error("Erro ao obter os dados do usuário:", err);
      }
    });
  }

  checkStoreApps() {
    if (!this.products || !this.store_id) {
      return;
    }

    this.products.forEach((product) => {
      // Cache-first com ETag.
      const storeAppResource = this.productService.getAppsStoreRevalidated(product.key);

      toObservable(storeAppResource.data, { injector: this.injector }).pipe(
        filter((response): response is any => response !== null)
      ).subscribe(response => {
          if (!response.store_apps || response.store_apps.length === 0) {
            return; // Interrompe a execução se store_apps não existir ou for vazio
          }

          const storeApp = response.store_apps?.find((app: any) => {
            return app.key.includes(product.key) && app.store_id === this.store_id;
          });

          if (storeApp && storeApp.active?.toString() === 'active') {
            product.isPinned = true;
            this.connected = true;
          } else {
            product.isPinned = false;
            this.connected = false;
            this.selectedStoreApp = null;
          }
      });

      toObservable(storeAppResource.error, { injector: this.injector }).pipe(
        filter((error): error is any => error !== null)
      ).subscribe(error => {
          console.error(`Erro ao buscar detalhes do app ${product.key}:`, error);
      });
    });
  }


  displayAguarde: boolean = false;
  sidebarLoading: boolean = false;
  connected: boolean = false;
  maskSensitiveData(value?: string): string {
    if (!value || value.length <= 6) {
      return value || ''; // Retorna o valor original se for muito curto para mascarar
    }
    const start = value.slice(0, 3); // Três primeiros caracteres
    const end = value.slice(-3); // Três últimos caracteres
    const masked = '.'.repeat(value.length - 6); // Pontos no meio
    return `${start}${masked}${end}`;
  }

  private isEcommerceCategory(product: Apps | null | undefined): boolean {
    return !!product?.category && product.category.toLowerCase() === 'ecommerce';
  }

  private hasActiveEcommerceIntegration(): boolean {
    return this.products.some(p => this.isEcommerceCategory(p) && p.isPinned);
  }

  isEcommerceLocked(product: Apps): boolean {
    return this.isEcommerceCategory(product) && !product.isPinned && this.hasActiveEcommerceIntegration();
  }

  onProductClick(product: Apps, opts?: { ignoreEcommerceLock?: boolean }): void {
    if (!opts?.ignoreEcommerceLock && this.isEcommerceLocked(product)) {
      return;
    }
    console.log('clicado ')
    console.log(product)
    this.selectedProduct = product;

    if (product.key === 'shopify') {
      this.sidebarLoading = true;
      this.showSidebar = true;
      // Cache-first com ETag.
      const shopifyStoreAppResource = this.productService.getAppsStoreRevalidated(product.key);

      toObservable(shopifyStoreAppResource.data, { injector: this.injector }).pipe(
        filter((response): response is any => response !== null)
      ).subscribe(response => {
          if (response.store_apps && response.store_apps.length > 0) {
            const storeApp = response.store_apps[0];
            const isActive = storeApp.active?.toString() === 'active' || storeApp.active === true;

            this.connected = isActive;
            this.selectedStoreApp = isActive ? storeApp : null;
            // Adicionar domínio no primeiro input e token no segundo
            if (this.selectedStoreApp?.form_value?.domain) {
              this.selectedStoreApp.form_value.domain = storeApp.form_value.domain;
            }
            if (this.selectedStoreApp && storeApp.access_token) {
              this.selectedStoreApp.access_token = storeApp.access_token;
            }


          } else {
            this.connected = false;
            this.selectedStoreApp = null;
          }
          this.sidebarLoading = false;
      });

      toObservable(shopifyStoreAppResource.error, { injector: this.injector }).pipe(
        filter((error): error is any => error !== null)
      ).subscribe(error => {
          this.sidebarLoading = false;
          console.error('Erro ao buscar detalhes do app:', error);
      });
    } else if (product.key === 'instagram') {
      this.sidebarLoading = true;
      this.showSidebarShopify = false;
      this.showSidebarInstagram = true;

      this.productService.getAppsStore(product.key).pipe(
        catchError(err => {
          console.error('Erro ao buscar store_apps do Instagram:', err);
          return EMPTY;
        }),
        switchMap(response => {
          const storeApps = response.store_apps?.[0];
          if (storeApps?.active) {
            this.connected = true;
            this.selectedStoreApp = storeApps;
          }

          // Agora puxamos dos Facebook Accounts
          return this.productService.getFacebookAccounts().pipe(
            map((res: any) =>
              // normalize: se vier um array, usa; se vier um objeto { accounts: [...] }, extrai
              Array.isArray(res) ? res : (res.accounts ?? [])
            ),
            catchError(err => {
              console.error('Erro ao buscar contas do Facebook:', err);
              return of([] as Array<{ id: string; name: string; picture: string }>);
            })
          );
        }),
        finalize(() => this.sidebarLoading = false)
      )
        .subscribe(
          (accounts) => {
            // preenche o sidebar com os dados vindos de facebook_accounts
            this.instagramAccounts = accounts.map((a: any) => ({
              uid: a.id.toString(),
              username: a.name,   // sem handle IG, mostramos o name do FB
              name: a.name,
              picture: a.picture
            }));
          },
          err => {
            console.error('Erro inesperado no fluxo Instagram:', err);
          }
        );
    } else if (product.key === 'tiktok') {
      this.sidebarLoading = true;
      this.showSidebarShopify = false;
      this.showSidebarInstagram = false;
      this.showSidebarTiktok = true;

      // Cache-first com ETag.
      const tiktokResource = this.productService.getTiktokAccountsRevalidated();

      toObservable(tiktokResource.data, { injector: this.injector }).pipe(
        filter((accounts): accounts is TiktokAccountVM[] => accounts !== null)
      ).subscribe(accounts => {
          this.tiktokAccounts = accounts;
          this.sidebarLoading = false;
      });

      toObservable(tiktokResource.error, { injector: this.injector }).pipe(
        filter((err): err is any => err !== null)
      ).subscribe(() => {
          this.sidebarLoading = false;
      });
    } else if (product.key === 'nuvemshop') {
      this.sidebarLoading = true;
      this.showSidebarNuvemShop = true;
      this.showSidebarShopify = false;
      this.showSidebarInstagram = false;
      this.showSidebarTiktok = false;

      this.productService.getAppsStore(product.key).pipe(
        catchError(err => {
          console.error('Erro ao buscar detalhes do app nuvemshop:', err);
          this.selectedStoreApp = null;
          this.connected = false;
          return of(null);
        }),
        switchMap(response => {

          console.log('nuvemshop')
          console.log(response)
          const storeApp = response?.store_apps?.[0];

          if (storeApp && storeApp.active?.toString() === 'active') {
            this.connected = true;
            this.selectedStoreApp = storeApp;
          } else {
            this.connected = false;
            this.selectedStoreApp = null;
          }

          return this.productService.getNuvemshopAccounts();
        }),
        finalize(() => this.sidebarLoading = false)
      ).subscribe({
        next: accounts => {
          let enrichedAccounts = accounts && accounts.length
            ? accounts
            : [];

          const fallbackDomain = (this.selectedStoreApp as any)?.domain || this.selectedStoreApp?.form_value?.domain;

          if (!enrichedAccounts.length && fallbackDomain && this.selectedStoreApp) {
            enrichedAccounts = [{
              uid: this.selectedStoreApp.uid,
              store_name: 'Minha loja',
              domain: fallbackDomain
            }];
          }

          this.nuvemshopAccounts = enrichedAccounts;
          this.connected = !!this.selectedStoreApp || enrichedAccounts.length > 0;
        },
        error: err => {
          console.error('Erro ao carregar contas da Nuvemshop:', err);
          this.nuvemshopAccounts = [];
          this.connected = !!this.selectedStoreApp;
        }
      });
    } else if (product.key === 'google') {
      this.sidebarLoading = true;
      this.showSidebarShopify = false;
      this.showSidebarInstagram = false;
      this.showSidebarTiktok = false;
      this.showSidebarGoogle = true;

      // Cache-first com ETag.
      const googleResource = this.productService.getGoogleAccountsRevalidated();

      toObservable(googleResource.data, { injector: this.injector }).pipe(
        filter((accounts): accounts is GoogleAccountVM[] => accounts !== null)
      ).subscribe(accounts => {
          this.googleAccounts = accounts;
          this.sidebarLoading = false;
      });

      toObservable(googleResource.error, { injector: this.injector }).pipe(
        filter((err): err is any => err !== null)
      ).subscribe(() => {
          this.sidebarLoading = false;
      });
    } else if (product.key === 'ga4') {
      this.sidebarLoading = true;
      this.showSidebarShopify = false;
      this.showSidebarInstagram = false;
      this.showSidebarTiktok = false;
      this.showSidebarGoogle = false;
      this.showSidebarGa4 = true;

      // Cache-first com ETag.
      const ga4Resource = this.productService.getGa4AccountsRevalidated();

      toObservable(ga4Resource.data, { injector: this.injector }).pipe(
        filter((accounts): accounts is Ga4AccountVM[] => accounts !== null)
      ).subscribe(accounts => {
          this.ga4Accounts = accounts;
          this.sidebarLoading = false;
      });

      toObservable(ga4Resource.error, { injector: this.injector }).pipe(
        filter((err): err is any => err !== null)
      ).subscribe(() => {
          // Pode limpar contas se quiser ou exibir toast
          this.ga4Accounts = [];
          this.sidebarLoading = false;
      });
    }



  }
  isSavingDimensions: boolean = false;
  showSidebarNuvemShop: boolean = false;

  onSaveDimensions(event: { uid: string, allProperties: any[], selectedPropertyIds: string[] }) {
    this.isSavingDimensions = true;
    this.productService.saveGa4CustomDimensions(event.uid, event.allProperties, event.selectedPropertyIds)
      .subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'OK', detail: 'Dimensões salvas' })
          this.isSavingDimensions = false;
        },
        error: err => {
          this.errorHandler.handle(err, err?.message || err);
          this.isSavingDimensions = false;
        }
      });
  }

  onSaveGa4Properties(event: { uid: string, properties: string[] }) {
    this.productService.saveGa4Properties(event.uid, event.properties).subscribe({
      next: () => {
        // Sucesso! Se quiser, mostre um toast.
      },
      error: err => {
        // Mostre erro ou faça rollback, se necessário.
        console.error('Erro ao salvar propriedades:', err);
      }
    });
  }

  closeSidebarGa4() { this.showSidebarGa4 = false; }
  showSidebarGa4: boolean = false;
  ga4Accounts: Ga4AccountVM[] = [];
  removeInstagramAccount(account: { uid: string }) {
    this.confirmationService.confirm({
      message: 'Você realmente deseja remover esta conta do Instagram?',
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // Só executa a remoção se o usuário confirmar
        this.productService
          .destroyInstagramAccount(account.uid)
          .subscribe(() => {
            this.messageService.add({ severity: 'success', detail: 'Conta removida' });
            this.instagramAccounts = this.instagramAccounts.filter(a => a.uid !== account.uid);


            // ✅ Se não tiver mais contas, remove o "Instalado" do Instagram
            if (this.instagramAccounts.length === 0) {
              const product = this.products.find(p => p.key === 'instagram');
              if (product) {
                product.isPinned = false;
              }
            }
          });
      },
      reject: () => {
        // Não faz nada se o usuário cancelar
      }
    });
  }



  closeSidebar(): void {
    this.showSidebar = false;
    this.selectedProduct = null;
  }
  closeSidebarInsta(): void {
    this.showSidebarInstagram = false;
    this.selectedProduct = null;
  }
  displayDialogSidebar: boolean = false;
  loadingBtn: boolean = false;
  confirmRemove() {
    const skipSubscriptionCheck = this.selectedProduct?.key !== 'shopify';

    this.confirmationService.confirm({
      message: 'Você realmente deseja remover esta integração?',
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.displayDialogSidebar = true;
        this.loadingBtn = true;
        this.removeApp(skipSubscriptionCheck);
      },
      reject: () => {
      }
    });
  }

  removeApp(skipSubscriptionCheck: boolean = false) {
    console.log('removeApp')
    if (!this.selectedStoreApp) return;
    // 🔹 Fechar qualquer diálogo aberto antes de exibir um novo
    this.confirmationService.close();
    // 🔹 Verificar se a assinatura está ativa e exibir a confirmação antes de remover
    if (!skipSubscriptionCheck && (this.userSubType || 0) !== 0 && (this.userSubsStatus || '').toLowerCase() === 'active') {
      setTimeout(() => {
        this.confirmationService.confirm({
          message: 'Você tem uma assinatura ativa. Se remover o app, sua assinatura será cancelada. Deseja continuar?',
          header: 'Confirmação',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.cancelSubscription();
          },
          reject: () => {
            this.loadingBtn = false;
          }
        });

        // 🔹 Forçar detecção de mudanças
        this.cdr.detectChanges();
      }, 300);
    } else {
      this.proceedWithRemoveApp(); // 🔹 Remove o app diretamente se não houver assinatura ativa
    }
  }
  removeMyshopify(domain: string | undefined): string {
    if (!domain) return '';
    return domain.replace('.myshopify.com', '');
  }
  async cancelSubscription() {
    const obs = await this.pedidosService.cancelShopifySubscription();
    obs.subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Assinatura cancelada',
          detail: 'Assinatura cancelada com sucesso!'
        });

        // 🔹 Atualizar o estado do usuário para "Free"
        this.userSubType = 0;

        // 🔹 Após cancelar a assinatura, prosseguir com a remoção do app
        this.proceedWithRemoveApp();
      },
      error: (error: any) => {

        let errorMessage = 'Erro desconhecido ao cancelar assinatura.';
        if (error.error && error.error.details && Array.isArray(error.error.details)) {
          errorMessage = error.error.details.map((err: any) => err.message).join(', ');
        } else if (error.error && error.error.error) {
          errorMessage = error.error.error;
        }


        this.errorHandler.handle(error, errorMessage);
      }
    });
  }


  proceedWithRemoveApp() {
    const selectedUid = this.selectedStoreApp?.uid;
    if (selectedUid) {
      this.productService.removeAppsStore(selectedUid).subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Integração Deletada',
            detail: 'A integração foi deletada com sucesso!'
          });

          this.connected = false;
          this.selectedStoreApp = null;
          this.loadingBtn = false;
          if (this.selectedProduct?.key === 'nuvemshop') {
            this.nuvemshopAccounts = [];
          }

          // 🔹 Atualizar o estado do produto para remover o pin
          if (this.selectedProduct) {
            const product = this.products.find(p => p.key === this.selectedProduct?.key);
            if (product) {
              product.isPinned = false;  // ✅ Remover “Instalado” do app correto
            }
          }
        },
        error: (error) => {
          this.loadingBtn = false;
          let message = '';

          if ([400, 403, 401, 404].includes(error.status)) {
            message = error.error.message;
          } else if (error.status === 500) {
            message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
          }

          if (message) {
            this.showErrorDialog(message); // 🔹 Mostra a mensagem de erro no `p-confirmDialog`
          }
        }
      });
    } else {
      this.loadingBtn = false;
      this.showErrorDialog('Não foi possível identificar a integração para remover.');
    }
  }


  connectApp(): void {
    this.loadingBtn = true;
    console.log('app')
    console.log(this.selectedProduct?.key)

    if (this.selectedProduct?.key === 'instagram') {
      this.instagramConnection();
    } else if (this.selectedProduct?.key === 'nuvemshop') {
      this.nuvemshopConnection();
    } else {
      this.shopifyConnection(); //
    }
  }

  // AppsComponent
  private oauthChannel: BroadcastChannel | null = null;

  private startOAuthPopupListener(): void {

    if (this.oauthChannel) return;
    this.oauthChannel = new BroadcastChannel('oauth-channel');

    this.oauthChannel.onmessage = (event) => {

      switch (event.data?.type) {
        case 'instagram-connected':
        case 'shopify-connected':
        case 'tiktok-connected':
        case 'google-connected':
        case 'ga4-connected':
        case 'nuvemshop-connected':
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            const key = (event.data.type as string).replace('-connected', '');
            localStorage.setItem('openIntegrationSidebar', key);
            window.location.reload();
          }, 0);
          break;

        default:
          console.warn('⚠️ Tipo de mensagem desconhecido:', event.data?.type);
          break;
      }
    };

  }


  tiktokAccounts: TiktokAccountVM[] = [];
  nuvemshopAccounts: NuvemshopAccountVM[] = [];
  showSidebarTiktok = false;
  googleAccounts: GoogleAccountVM[] = [];
  showSidebarGoogle = false;
  // chame isso no constructor/ngOnInit do componente que chama tiktokConnection()
  private storageBridge?: BroadcastChannel;

  private setupStorageBridgeForPopup(): void {
    if (this.storageBridge) return;
    this.storageBridge = new BroadcastChannel('oauth-storage');

    this.storageBridge.onmessage = (e) => {
      if (e.data?.type === 'request-storage') {
        // Envie as chaves que a popup precisa
        this.storageBridge?.postMessage({
          type: 'storage-dump',
          payload: {
            SelectedStoreId: localStorage.getItem('ss_SelectedStoreId'),
            user_id: localStorage.getItem('user_id'),
            // adicione outras chaves se quiser
          }
        });
      }
    };
  }

  tiktokConnection(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener();

    const clientKey = 'sbawrbor1sxz11n05g'; // sua client_key
    const redirectUri = encodeURIComponent(`${environment.appBaseUrl}/auth/tiktok`);
    const scopes = encodeURIComponent('user.info.basic,user.info.profile,video.list');

    const isNative = Capacitor.isNativePlatform();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
    let stateObj: any = { selectedStoreId };
    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }
    stateObj.nonce = Math.random().toString(36).substring(2);
    const state = btoa(JSON.stringify(stateObj));


    const url =
      `https://www.tiktok.com/v2/auth/authorize/?client_key=${clientKey}` +
      `&redirect_uri=${redirectUri}&response_type=code&scope=${scopes}&state=${state}`;

    window.open(url, 'TikTok Login', 'width=600,height=700,noopener,noreferrer');
  }

  ga4Connection(): void { 
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener();
    // 
    const clientId = '1094728979349-4j3ct8vvgpabfiqmpbp6a6516agmm1nm.apps.googleusercontent.com';
    const redirectUri = encodeURIComponent(`${environment.appBaseUrl}/auth/ga-4`);
    const scopes = encodeURIComponent(
      'openid email profile ' +
      'https://www.googleapis.com/auth/analytics.readonly ' +
      'https://www.googleapis.com/auth/analytics.edit'

    );

    const isNative = (window as any).Capacitor?.isNativePlatform?.() || false; // depende de como você importa Capacitor
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';

    let stateObj: any = { selectedStoreId };

    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }

    stateObj.nonce = Math.random().toString(36).substring(2);

    const state = btoa(JSON.stringify(stateObj));

    const url =
      `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}` +
      `&redirect_uri=${redirectUri}` +
      `&response_type=code` +
      `&scope=${scopes}` +
      `&access_type=offline` +
      `&include_granted_scopes=true` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(state)}`;

    console.log(url)

    window.open(url, 'GA4 Login', 'width=600,height=700,noopener,noreferrer');
  }



  googleConnection(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener();

    const clientId = '814215832533-b4qkagjc0h2voi3cf80prscqj16bfn5n.apps.googleusercontent.com';
    const redirectUri = encodeURIComponent(`${environment.appBaseUrl}/auth/youtube`);
    const scopes = encodeURIComponent(
      'openid email profile ' +
      'https://www.googleapis.com/auth/youtube.readonly'
    );


    const isNative = Capacitor.isNativePlatform();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';

    let stateObj: any = { selectedStoreId };

    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }

    stateObj.nonce = Math.random().toString(36).substring(2);

    const state = btoa(JSON.stringify(stateObj));

    const url =
      `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}` +
      `&redirect_uri=${redirectUri}` +
      `&response_type=code` +
      `&scope=${scopes}` +
      `&access_type=offline` +
      `&include_granted_scopes=true` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(state)}`;

    window.open(url, 'Google Login', 'width=600,height=700,noopener,noreferrer');
  }

  removeGa4Account(acct: Ga4AccountVM): void {
    this.confirmationService.confirm({
      message: `Você realmente deseja remover a conta ${acct.email || acct.accountName || acct.uid}?`,
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.displayAguarde = true;
        const snapshot = [...this.ga4Accounts];
        this.ga4Accounts = this.ga4Accounts.filter(a => a.uid !== acct.uid);

        this.productService.deleteGa4Account(acct.uid).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Removida',
              detail: 'Integração do GA4 removida.'
            });

            if (this.ga4Accounts.length === 0) {
              const product = this.products.find(p => p.key === 'ga4');
              if (product) product.isPinned = false;
            }
            this.displayAguarde = false;
          },
          error: (error: any) => {
            this.displayAguarde = false;
            this.ga4Accounts = snapshot;
            this.errorHandler.handle(error, 'Falha ao remover integração.');
          }
        });
      }
    });
  }



  removeGoogleAccount(acct: GoogleAccountVM): void {
    this.confirmationService.confirm({
      message: `Você realmente deseja remover a conta ${acct.email || acct.name || acct.uid}?`,
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const snapshot = [...this.googleAccounts];
        this.googleAccounts = this.googleAccounts.filter(a => a.uid !== acct.uid);

        this.productService.deleteGoogleAccount(acct.uid).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Removida',
              detail: 'Integração do Youtube removida.'
            });

            if (this.googleAccounts.length === 0) {
              const product = this.products.find(p => p.key === 'google');
              if (product) {
                product.isPinned = false;
              }
            }
          },
          error: (error) => {
            this.googleAccounts = snapshot;
            this.errorHandler.handle(error, 'Falha ao remover integração.');

          }
        });
      },
      reject: () => {
        // opcional: ação alternativa
      }
    });
  }


  closeSidebarGoogle() {
    this.showSidebarGoogle = false;
  }


  removeTiktokAccount(acct: TiktokAccountVM): void {
    this.confirmationService.confirm({
      message: `Você realmente deseja remover a conta ${acct.username || acct.name}?`,
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const snapshot = [...this.tiktokAccounts];
        this.tiktokAccounts = this.tiktokAccounts.filter(a => a.uid !== acct.uid);

        this.productService.deleteTiktokAccount(acct.uid).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Removida',
              detail: 'Integração do TikTok removida.'
            });


            if (this.tiktokAccounts.length === 0) {
              const product = this.products.find(p => p.key === 'tiktok');
              if (product) {
                product.isPinned = false;
              }
            }

          },
          error: (error) => {
            this.tiktokAccounts = snapshot;
            this.errorHandler.handle(error, 'Falha ao remover integração.');

          }
        });
      },
      reject: () => {
        // opcional: log ou ação alternativa
      }
    });
  }


  closeSidebarTikTok(): void {
    this.showSidebarTiktok = false;
  }


  instagramConnection(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener(); // ✅ inicia o listener

    const clientId = '4107655592889616';
    const redirectUri = encodeURIComponent(`${environment.appBaseUrl}/auth/instagram`);
    const scopes = [
      'instagram_basic',
      'pages_show_list',
      'pages_manage_metadata',
      'instagram_manage_comments',
      'pages_read_engagement',
      'business_management',
      'instagram_manage_insights',
    ].join(',');

    const isNative = Capacitor.isNativePlatform();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
    let stateObj: any = { selectedStoreId };
    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }
    stateObj.nonce = Math.random().toString(36).substring(2);
    const state = btoa(JSON.stringify(stateObj));


    const oauthUrl = [
      'https://www.facebook.com/v22.0/dialog/oauth?',
      `client_id=${clientId}`,
      `&redirect_uri=${redirectUri}`,
      `&scope=${encodeURIComponent(scopes)}`,
      `&response_type=code`,
      `&state=${encodeURIComponent(state)}`,
    ].join('');

    window.open(oauthUrl, 'Instagram Login', 'width=600,height=700');
  }


  nuvemshopConnection(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';

    const stateObj = {
      selectedStoreId,
      nonce: Math.random().toString(36).substring(2),
    };

    // state pra CSRF + transportar seu contexto (igual você faz hoje)
    const state = btoa(JSON.stringify(stateObj));

    const appId = environment.nuvemshopAppId;

    const authUrl =
      `https://www.nuvemshop.com.br/apps/${appId}/authorize?state=${encodeURIComponent(state)}`;

    window.open(authUrl, 'Nuvemshop Login', 'width=600,height=700');
  }


  shopifyConnection(): void { // dd
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener(); // ✅ inicia o listener

    const isNative = Capacitor.isNativePlatform();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
    let stateObj: any = { selectedStoreId };

    //
    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }
    stateObj.nonce = Math.random().toString(36).substring(2);
    const state = btoa(JSON.stringify(stateObj));


    const redirectUri = encodeURIComponent(`${environment.appBaseUrl}/auth/shopify`);

    const authUrl = `https://slicksell-test.myshopify.com/admin/oauth/authorize?` +
      `client_id=${environment.shopifyClientId}` +
      `&scope=read_content,read_discounts,read_gift_cards,read_inventory,read_orders,read_products,read_themes,write_pixels,write_products,write_script_tags,write_themes` +
      `&redirect_uri=${redirectUri}` +
      `&state=${encodeURIComponent(state)}`;

    if (isNative) {
      void Browser.open({ url: authUrl });
      return;
    }

    window.location.assign(authUrl);
  }
  private sub: any;
  ngOnDestroy(): void {
    if (this.oauthChannel) {
      this.oauthChannel.close();
      this.oauthChannel = null;
    }
    this.sub?.unsubscribe();
  }

  showErrorDialog(message: string) {
    this.confirmationService.confirm({
      message: message,
      header: 'Erro',
      icon: 'pi pi-times',
      accept: () => {
        // Lógica de aceitação, se necessário
      }
    });
  }



  //closeSidebar(){}
  // lista de contas Instagram que o usuário já vinculou
  instagramAccounts: Array<{
    username: string;
    name: string;
    picture?: string;
    uid: string;
  }> = [];
  // também um flag pra saber qual sidebar está aberta:
  showSidebarShopify = false;
  showSidebarInstagram = false;
}

